import { Icon } from "antd";
import React from "react";

const QuantityComp = ({ quantity, setQuantity }) => {
  const increaseQuantity = () => setQuantity((prev) => prev + 1);
  const decraseQuantity = () => {
    if (quantity === 1) return;
    setQuantity((prev) => prev - 1);
  };

  return (
    <div className="misc-product__quantity">
      <div className="misc-product__quantity-wrapper">
        <Icon
          type="minus"
          className={`misc-product__quantity-minus ${
            quantity === 1 ? "disabled" : ""
          }`}
          onClick={decraseQuantity}
        />
        <input type="text" value={quantity} />
        <Icon
          type="plus"
          className="misc-product__quantity-plus"
          onClick={increaseQuantity}
        />
      </div>
    </div>
  );
};

export default QuantityComp;



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/basket/miscProduct/quantity.js